import { useStyles } from '@archipro-design/aria';
import React from 'react';
import useVariantPrice from '@modules/product/hook/use-variant-price';
import * as S from './VariantPricing.mobile.style';
import { useVariantSelectionState } from '@modules/product/context/VariantSelectionContext';
import { PriceUnit } from './PriceUnit';
import type CurrencyAmount from '../../type/currency-amount';
import type { ProductPricingTypeEnum } from 'generated/graphql';
import { buildPriceRangeString } from './VariantPricing';

interface VariantPricingProps {
    showMaxPrice: boolean;
    priceToShow: CurrencyAmount;
    pricingType: ProductPricingTypeEnum;
}

const VariantPricingMobile = ({
    priceToShow,
    showMaxPrice,
    pricingType,
}: VariantPricingProps) => {
    const { css } = useStyles();
    const { selectedVariant } = useVariantSelectionState();
    const { price, isOnSale, maxPrice, retailPrice, isPriceRange } =
        useVariantPrice(pricingType);
    return (
        <div className={css(S.VariantPricing)}>
            {isPriceRange && (
                <div className={css(S.PricePrefix)}>
                    {price.Amount > 0 ? 'From' : 'Up to'}
                </div>
            )}
            {isOnSale && !isPriceRange && (
                <del className={css(S.RetailPrice)}>
                    {retailPrice.ShortFormat.replace(/\.00$/, '')}
                </del>
            )}
            <div className={css(S.Price)}>
                {buildPriceRangeString(
                    priceToShow.ShortFormat,
                    maxPrice.ShortFormat,
                    showMaxPrice,
                )}
                {isPriceRange ? <span>*</span> : null}
            </div>
            <div className={css(S.Subtitle)}>
                {isPriceRange && <span>*Price indication</span>}
                {selectedVariant && (
                    <>
                        {isPriceRange && ' '}
                        <PriceUnit
                            variant={selectedVariant}
                            isPriceRange={isPriceRange}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default VariantPricingMobile;
